import { create } from "zustand";
import { persist } from "zustand/middleware";

// Define the shop store type
export interface ShopState {
    activeShop: { id: string; name: string } | null;
    setActiveShop: (shop: { id: string; name: string } | null) => void;
    resetShop: () => void;
}

// Create a persisted Zustand store
export const useShopStore = create<ShopState>()(
    persist(
        (set) => ({
            activeShop: null,
            setActiveShop: (shop) => set({ activeShop: shop }),
            resetShop: () => set({ activeShop: null }),
        }),
        {
            name: "shop-storage", // unique name for localStorage key
        }
    )
); 